
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
@Component
export default class DeleteButtonWithConfirm extends Vue {
  @Prop()
  private correctName!: string
  @Prop()
  private correct!: string
  @Prop({ default: null })
  private comment!: string

  private confirm: string | null = null
  private dialog = false

  @Emit("deleteOk")
  private deleteOk() {
    this.close()
  }

  private open() {
    this.dialog = true
  }

  private close() {
    this.confirm = null
    this.dialog = false
  }

  get check(): boolean {
    return this.correct !== this.confirm
  }
}
